import { onFind } from "@elements/init-modules-in-scope";
import { findIn, on, closest, removeAttribute, setAttribute } from '@elements/dom-utils';

const defaultSelectors = {
    base: '.js-video-control',
    button: '.js-video-control__button',
    video: 'video',
    iconPause: '.icon-pause',
    iconPlay: '.icon-play'
};

export function init(selectors = defaultSelectors) {
    onFind(selectors.button, function (controlElement) {
        on('click', (evt) => {
            evt.preventDefault();

            const embedContainer = closest(selectors.base, controlElement);
            if (!embedContainer) return;

            const video = findIn(selectors.video, embedContainer);
            if (!video) return;

            const iconPause = findIn(selectors.iconPause, embedContainer);
            const iconPlay = findIn(selectors.iconPlay, embedContainer);

            if (video.paused) {
                video.play();
                if (iconPause) {
                    removeAttribute('hidden', iconPause);
                }
                if (iconPlay) {
                    setAttribute('hidden', 'hidden', iconPlay);
                }
            } else {
                video.pause();
                if (iconPlay) {
                    removeAttribute('hidden', iconPlay);
                }
                if (iconPause) {
                    setAttribute('hidden', 'hidden', iconPause);
                }
            }
        }, controlElement);
    });
}